import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Tomes } from './components/Tomes';
import { InsideLook } from './components/InsideLook';
import { Bonuses } from './components/Bonuses';
import { Transformation } from './components/Transformation';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { initMetaPixel, pixelNoscriptSrc } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-white" data-id="element-0" data-mp="28tmex2vosax8">
      <noscript data-id="element-1" data-mp="28sl32w6ujkeg">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={pixelNoscriptSrc} alt="" data-id="element-2" data-mp="28sbe9bxjfjac" />
      </noscript>
      <Hero data-id="element-3" data-mp="3ijxpcqos80jw" />
      <main data-id="element-4" data-mp="3ik7eyd5x05p2">
        <PainPoints data-id="element-5" data-mp="3ikr002qv3a7b" />
        <Solution data-id="element-6" data-mp="3ij63w8owfj7c" />
        <Tomes data-id="element-7" data-mp="3ijpd910hgz9r" />
        <InsideLook data-id="element-8" data-mp="3ii4sg33z0up3" />
        <Bonuses data-id="element-9" data-mp="3mlayb9n68jv1" />
        <Transformation data-id="element-10" data-mp="3mkrc3gqhn9b7" />
        <Offer data-id="element-11" data-mp="3mjzs7369700r" />
        <Guarantee data-id="element-12" data-mp="3mjg9vlcoy9m7" />
        <Testimonials data-id="element-13" data-mp="3rc9du70c5dx8" />
        <Faq data-id="element-14" data-mp="3rbrc4uuwm7hx" />
        <FinalCta data-id="element-15" data-mp="3rdaq2et386gj" />
      </main>
      <Footer data-id="element-16" data-mp="3rd191gq0t9mz" />
    </div>;
}